import { Card, Col, List, Radio, Row, DatePicker, Button, Drawer, Table } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Request from '../../request';
import common from '../common.less'
import LatestFollowUp from "../../components/_utils/latestFollowup";
import {
    FaUsers,
    FaUserCheck,
    FaPassport,
    FaRegCalendarAlt,
    FaClipboardCheck,
    FaFileAlt,
    FaHeadset,
    FaFileSignature,
    FaCheckCircle,
    FaTimesCircle,
    FaClock,
    FaFileUpload,
    FaMoneyCheckAlt,
    FaFileInvoiceDollar,
    FaFolderOpen,
    FaUserTimes,
    FaPhoneSlash,
    FaUserClock,
    FaBriefcase,
    FaQuestionCircle,
    FaRegSadCry,
    FaExclamationTriangle,
    FaSkull,
    FaPhoneAlt,
    FaPauseCircle,
    FaRegMeh,
    FaHandPointRight,
    FaCheckDouble,
    FaHandsHelping,
    FaRegSmileBeam,
    FaExchangeAlt,
    FaUserPlus,
    FaFolder,
    FaBook,
    FaMoneyBillWave
} from "react-icons/fa"
import './css/frontOfficeDashboard.css';
import ListDrawer from './list';
import { TableComp } from 'sz-react-utils';
import { } from 'react-icons/fa';

const statusMeta = {
    "Offer Done": {
        icon: <FaCheckCircle />,
        color: "bg-color-green",
    },
    "Unconditional Offer Received": {
        icon: <FaClipboardCheck />,
        color: "bg-color-blue",
    },
    "Conditional Offer Received": {
        icon: <FaClipboardCheck />,
        color: "bg-color-yellow",
    },
    "Offer Pending": {
        icon: <FaClock />,
        color: "bg-color-orange",
    },
    "Offer Rejected": {
        icon: <FaTimesCircle />,
        color: "bg-color-red",
    }
};
const data = [
    { name: 'Group A', value: 525 },
    { name: 'Group B', value: 175 }
];

const COLORS = ['#56BFEE', '#69ccf9'];
const { RangePicker } = DatePicker;


const visaStatusMeta = {
    "CAQ Waiting": {
        icon: <FaClock />,
        color: "bg-color-1"
    },
    "COE/Receipt Pending": {
        icon: <FaFileInvoiceDollar />,
        color: "bg-color-2"
    },
    "COE/Receipt Received": {
        icon: <FaMoneyCheckAlt />,
        color: "bg-color-3"
    },
    "Final Visa File Review": {
        icon: <FaClipboardCheck />,
        color: "bg-color-4"
    },
    "Financial Documents Pending": {
        icon: <FaFolderOpen />,
        color: "bg-color-5"
    },
    "Financial Documents Received": {
        icon: <FaFolder />,
        color: "bg-color-6"
    },
    "GIC Waiting": {
        icon: <FaClock />,
        color: "bg-color-7"
    },
    "Student Kit & Funds Requirement Issued": {
        icon: <FaBook />,
        color: "bg-color-8"
    },
    "Tution Fee Paid": {
        icon: <FaMoneyBillWave />,
        color: "bg-color-9"
    },
    "Tution Fee Pending": {
        icon: <FaFileInvoiceDollar />,
        color: "bg-color-10"
    },
    "Tution Fee Received": {
        icon: <FaMoneyCheckAlt />,
        color: "bg-color-11"
    },
    "Verification Pending": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-12"
    },
    "Visa File Dispatched": {
        icon: <FaFileUpload />,
        color: "bg-color-13"
    },
    "Visa File Submission": {
        icon: <FaFileSignature />,
        color: "bg-color-14"
    },
    "Refund Waiting": {
        icon: <FaFileInvoiceDollar />,
        color: "bg-color-1"
    },
    "Visa Approved": {
        icon: <FaClipboardCheck />,
        color: "bg-color-2"
    },
    "Visa Refused": {
        icon: <FaTimesCircle />,
        color: "bg-color-3"
    },
    "Visa Waiting": {
        icon: <FaClock />,
        color: "bg-color-4"
    }
}

// const visaStatusMeta = {
//     "Visa File Dispatched": {
//         icon: <FaFileUpload />,
//         color: "bg-color-1"
//     },
//     "Visa Waiting": {
//         icon: <FaClock />,
//         color: "bg-color-2"
//     },
//     "Tution Fee Received": {
//         icon: <FaMoneyCheckAlt />,
//         color: "bg-color-3"
//     },
//     "Final Visa File Review": {
//         icon: <FaClipboardCheck />,
//         color: "bg-color-4"
//     },
//     "Tution Fee Pending": {
//         icon: <FaFileInvoiceDollar />,
//         color: "bg-color-5"
//     },
//     "Financial Documents Pending": {
//         icon: <FaFolderOpen />,
//         color: "bg-color-6"
//     },
//     "Visa Refused": {
//         icon: <FaTimesCircle />,
//         color: "bg-color-7"
//     }
// };

const followUpStatusMeta = {
    "Not Interested": {
        icon: <FaRegSadCry />,
        color: "bg-color-red",
    },
    "Didn't Pick up Call": {
        icon: <FaPhoneSlash />,
        color: "bg-color-orange",
    },
    "Number out of service": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-dark-red",
    },
    "Dead": {
        icon: <FaSkull />,
        color: "bg-color-dark-red",
    },
    "Active": {
        icon: <FaUsers />,
        color: "bg-color-blue",
    },
    "Busy, Call Later": {
        icon: <FaUserClock />,
        color: "bg-color-yellow",
    },
    "Number not connected": {
        icon: <FaPhoneAlt />,
        color: "bg-color-grey",
    },
    "Out Of town": {
        icon: <FaPauseCircle />,
        color: "bg-color-orange",
    },
    "Cold": {
        icon: <FaRegMeh />,
        color: "bg-color-grey",
    },
    "Untouched": {
        icon: <FaQuestionCircle />,
        color: "bg-color-grey",
    },
    "Job": {
        icon: <FaBriefcase />,
        color: "bg-color-blue",
    },
    "OBD Call - Not interested": {
        icon: <FaUserTimes />,
        color: "bg-color-red",
    },
    "Another query": {
        icon: <FaHandPointRight />,
        color: "bg-color-blue",
    },
    "Commission Done": {
        icon: <FaCheckDouble />,
        color: "bg-color-green",
    },
    "Spouse Visa": {
        icon: <FaHandsHelping />,
        color: "bg-color-blue",
    },
    "OBD Call - Interested": {
        icon: <FaRegSmileBeam />,
        color: "bg-color-green",
    },
    "Final Decision Pending": {
        icon: <FaExclamationTriangle />,
        color: "bg-color-yellow",
    },
    "B2B": {
        icon: <FaExchangeAlt />,
        color: "bg-color-blue",
    }
};



class VisitorVisaLeads extends Component {
    state = {
        visible: true,
        data: []
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose();
        }, 500)
    }

    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    componentDidMount() {
        let { data } = this.props
        this.setState({ data })
    }

    render() {
        let { visible, data } = this.state;
        const columns = [
            {
                title: "ID",
                key: "id",
                dataIndex: "id",
            },
            {
                title: "Applicant Name",
                key: "applicantName",
                dataIndex: "applicantName",

            },
            {
                title: "Counsellor",
                key: "counsellorName",
                dataIndex: "counsellorId.name",
            },
            {
                title: "Conact",
                key: "mobwap",
                dataIndex: "mobwap",
                render: (val, record) => {
                    return (
                        <div>{record.countryCode ? `${record.countryCode}-` : null}{record.mobileNumber ? record.mobileNumber : ""}</div>
                    )
                },
            },
            {
                title: "Follow Up",
                key: "followUp",
                dataIndex: "followUp",
                render: (text, record) => {
                    return <LatestFollowUp info={text} />;
                },
            },
            {
                title: "Source",
                key: "source",
                dataIndex: "source"
            },
            {
                title: "Last Updated By",
                key: "updatedByUser",
                dataIndex: "updatedByUser",
                render: (text, record) => {
                    return (
                        <div>
                            <div className={common.user}>
                                {record.updatedByUser
                                    ? record.updatedByUser.name
                                    : record.createdByUser
                                        ? record.createdByUser.name
                                        : ""}
                            </div>
                            <small>{text ? moment(text.time).format("lll") : ""}</small>
                        </div>
                    );
                },
            },
        ];
        return (
            <Drawer
                title={`Visitor Visa:- ${data.length}`}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={800}>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        dataSource={data}
                        // extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </Drawer>
        )
    }
}



class OperationManagerDashboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            time: {
                from: moment().startOf('day'),
                to: moment().endOf('day'),
            },
            drawer: false,
            drawerParam: {},
            applicationDeskStatus: {
                "Offer Done": { total: 0, arr: [] },
                "Unconditional Offer Received": { total: 0, arr: [] },
                "Conditional Offer Received": { total: 0, arr: [] },
                "Offer Pending": { total: 0, arr: [] },
                "Offer Rejected": { total: 0, arr: [] },
            },
            visaDeskStatus: {
                'CAQ Waiting': { total: 0, arr: [] },
                'COE/Receipt Pending': { total: 0, arr: [] },
                'COE/Receipt Received': { total: 0, arr: [] },
                'Final Visa File Review': { total: 0, arr: [] },
                'Financial Documents Pending': { total: 0, arr: [] },
                'Financial Documents Received': { total: 0, arr: [] },
                'GIC Waiting': { total: 0, arr: [] },
                'Student Kit & Funds Requirement Issued': { total: 0, arr: [] },
                'Tution Fee Paid': { total: 0, arr: [] },
                'Tution Fee Pending': { total: 0, arr: [] },
                'Tution Fee Received': { total: 0, arr: [] },
                'Verification Pending': { total: 0, arr: [] },
                'Visa File Dispatched': { total: 0, arr: [] },
                'Visa File Submission': { total: 0, arr: [] },
                'Refund Waiting': { total: 0, arr: [] },
                'Visa Approved': { total: 0, arr: [] },
                'Visa Refused': { total: 0, arr: [] },
                'Visa Waiting': { total: 0, arr: [] }
            },
            followupsCount: {
                "Not Interested": { total: 0, arr: [] },
                "Didn't Pick up Call": { total: 0, arr: [] },
                "Number out of service": { total: 0, arr: [] },
                "Dead": { total: 0, arr: [] },
                "Active": { total: 0, arr: [] },
                "Busy, Call Later": { total: 0, arr: [] },
                "Number not connected": { total: 0, arr: [] },
                "Out Of town": { total: 0, arr: [] },
                "Cold": { total: 0, arr: [] },
                "Untouched": { total: 0, arr: [] },
                "Job": { total: 0, arr: [] },
                "OBD Call - Not interested": { total: 0, arr: [] },
                "Another query": { total: 0, arr: [] },
                "Commission Done": { total: 0, arr: [] },
                "Spouse Visa": { total: 0, arr: [] },
                "OBD Call - Interested": { total: 0, arr: [] },
                "Final Decision Pending": { total: 0, arr: [] },
                "B2B": { total: 0, arr: [] },
            },
            todayLeads: {
                total: 0,
                arr: []
            },
            todayVisitedLeads: {
                total: 0,
                arr: []
            },
            visitorLeads: {
                total: 0,
                data: []
            },
            counsellingDeskLeads: {
                total: 0,
                arr: []
            },
            registrationDeskLeads: {
                total: 0,
                arr: []
            },
            applicationDeskLeads: {
                total: 0,
                arr: []
            },
            visaSupportLeads: {
                total: 0,
                arr: []
            },
            visaFillingLeads: {
                total: 0,
                arr: []
            },
            untouchedLeads: {
                total: 0,
                arr: []
            }
        }
    }

    async componentDidMount() {
        this.loadAllApis();
    }

    // deep merge status objects: update only keys coming from API
    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }


    // loadAllApis = async (params = {}) => {
    //     params.time = this.state.time;
    //     let response = await Request.getOfficeManagerData(params);
    //     this.setState({ ...response });
    // }

    loadAllApis = async (params = {}) => {
        params.time = this.state.time;

        let response = await Request.getOfficeManagerData(params);

        this.setState({
            applicationDeskStatus: this.mergeStatus(this.state.applicationDeskStatus, response.applicationDeskStatus),
            visaDeskStatus: this.mergeStatus(this.state.visaDeskStatus, response.visaDeskStatus),
            followupsCount: this.mergeStatus(this.state.followupsCount, response.followupsCount),
        });
    };



    chooseRangerPicker = (date, dateString) => {
        // Check if date array is valid and has two dates
        if (!date || !date[0] || !date[1]) {
            return; // do nothing if no dates are selected
        }

        this.setState({
            time: {
                from: moment(date[0]).startOf('day'),
                to: moment(date[1]).endOf('day'),
            }
        }, () => { this.loadAllApis() });
    }


    onOk = value => {
        this.loadAllApis();
    }


    render() {
        const { dispatch } = this.props;
        const { time,
            todayLeads,
            todayVisitedLeads,
            visitorLeads,
            counsellingDeskLeads,
            registrationDeskLeads,
            applicationDeskLeads,
            visaSupportLeads,
            drawer,
            drawerParam,
            visitorVisaLeadsDrawer,
            visaFillingLeads,
            applicationDeskStatus,
            visaDeskStatus,
            followupsCount,
            untouchedLeads,
        } = this.state;
        return (
            <div>
                <Card bordered={true}>
                    <Row>
                        <Col span={8}>
                            <h4>Filter by Date</h4>
                            <RangePicker
                                value={[time.from, time.to]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                                disabledDate={(current) => {
                                    return current && current > moment().endOf('day');
                                }}
                            />
                        </Col>
                    </Row>
                </Card>

                <div className='fod-container'>
                    {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                    {visitorVisaLeadsDrawer && visitorLeads.data && <VisitorVisaLeads data={visitorLeads.data} onClose={() => this.setState({ visitorVisaLeadsDrawer: false })} />}
                    <Row className="fod-row">

                        {/* New Leads */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaUsers /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">New Leads</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Today's Leads`, arr: todayLeads.arr, count: todayLeads.total }
                                        })}>{todayLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Walk Ins */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaUserCheck /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Walk Ins</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Walk Ins`, arr: todayVisitedLeads.arr, count: todayVisitedLeads.total }
                                        })}>{todayVisitedLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Visitor Visa */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaPassport /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Visitor Visa</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ visitorVisaLeadsDrawer: true })}>{visitorLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Counselling Desk */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-4 elevation-1"><FaRegCalendarAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Counselling Desk</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Counselling Desk`, arr: counsellingDeskLeads.arr, count: counsellingDeskLeads.total }
                                        })}>{counsellingDeskLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Registration Desk */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaClipboardCheck /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Registration Desk</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Registration Desk`, arr: registrationDeskLeads.arr, count: registrationDeskLeads.total }
                                        })}>{registrationDeskLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Application Desk */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-3 elevation-1"><FaFileAlt /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Application Desk</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Application Desk`, arr: applicationDeskLeads.arr, count: applicationDeskLeads.total }
                                        })}>{applicationDeskLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Visa Support */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-2 elevation-1"><FaHeadset /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Visa Support</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Visa Support`, arr: visaSupportLeads.arr, count: visaSupportLeads.total }
                                        })}>{visaSupportLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* Visa Filling */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-1 elevation-1"><FaFileSignature /></span>
                                <div className="info-box-content">
                                    <span className="info-box-text">Visa Filling</span>
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: `Visa Filling`, arr: visaFillingLeads.arr, count: visaFillingLeads.total }
                                        })}>{visaFillingLeads.total}</a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                        {/* UnTouched Leads */}
                        <Col span={6}>
                            <div className="info-box glass">
                                <span className="info-box-icon bg-color-blue elevation-1">
                                    <FaUserPlus />
                                </span>

                                <div className="info-box-content">
                                    <span className="info-box-text">Untouched Leads</span>

                                    <span className="info-box-number">
                                        <a
                                            onClick={() =>
                                                this.setState({
                                                    drawer: true,
                                                    drawerParam: {
                                                        title: `Untouched Leads`,
                                                        arr: untouchedLeads.arr,
                                                        count: untouchedLeads.total
                                                    }
                                                })
                                            }
                                        >
                                            {untouchedLeads.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </Col>

                    </Row>
                    <Card title="Application Status">
                        <Row className="fod-row">

                            {Object.keys(applicationDeskStatus).map((key) => {
                                const item = applicationDeskStatus[key];
                                const meta = statusMeta[key] || {};

                                return (
                                    <Col span={6} key={key}>
                                        <div className="info-box glass">
                                            <span className={`info-box-icon ${meta.color} elevation-1`}>
                                                {meta.icon}
                                            </span>

                                            <div className="info-box-content">
                                                <span className="info-box-text" title={key}>{key}</span>

                                                <span className="info-box-number">
                                                    <a onClick={() =>
                                                        this.setState({
                                                            drawer: true,
                                                            drawerParam: {
                                                                title: key,
                                                                arr: item.arr,
                                                                count: item.total
                                                            }
                                                        })
                                                    }>
                                                        {item.total}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}

                        </Row>
                    </Card>

                    <Card title="Visa Status" style={{ marginTop: 10 }}>
                        <Row className="fod-row">

                            {Object.keys(visaDeskStatus).map((key) => {
                                const item = visaDeskStatus[key];
                                const meta = visaStatusMeta[key] || {};

                                return (
                                    <Col span={6} key={key}>
                                        <div className="info-box glass">

                                            <span className={`info-box-icon ${meta.color} elevation-1`}>
                                                {meta.icon}
                                            </span>

                                            <div className="info-box-content">
                                                <span className="info-box-text" title={key}>{key}</span>

                                                <span className="info-box-number">
                                                    <a
                                                        onClick={() =>
                                                            this.setState({
                                                                drawer: true,
                                                                drawerParam: {
                                                                    title: key,
                                                                    arr: item.arr,
                                                                    count: item.total
                                                                }
                                                            })
                                                        }
                                                    >
                                                        {item.total}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}

                        </Row>
                    </Card>

                    <Card title="Follow Ups" style={{ marginTop: 10 }}>
                        <Row className="fod-row">

                            {Object.keys(followupsCount).map((key) => {
                                const item = followupsCount[key];
                                const meta = followUpStatusMeta[key] || {};

                                return (
                                    <Col span={6} key={key}>
                                        <div className="info-box glass">

                                            <span className={`info-box-icon ${meta.color} elevation-1`}>
                                                {meta.icon}
                                            </span>

                                            <div className="info-box-content">
                                                <span className="info-box-text" title={key}>{key}</span>

                                                <span className="info-box-number">
                                                    <a
                                                        onClick={() =>
                                                            this.setState({
                                                                drawer: true,
                                                                drawerParam: {
                                                                    title: key,
                                                                    arr: item.arr,
                                                                    count: item.total
                                                                }
                                                            })
                                                        }
                                                    >
                                                        {item.total}
                                                    </a>
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                );
                            })}

                        </Row>
                    </Card>




                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (OperationManagerDashboard)
